import { apiInstance } from './_base'

//
//

const BASE_URL = '/mini-app/account'

//
//

export const getTarget = async () => {
  const res = await apiInstance.get(`${BASE_URL}/target`, null)

  return res
}
